import StaleReportNotice from './StaleReportNotice.component';

export default StaleReportNotice;
